// extracted by mini-css-extract-plugin
export default {"container":"SectionChips_container__5wkT8","chips":"SectionChips_chips__ojZ5t"};